import {configureStore} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";
import {authSlice} from "./slice/auth";

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        // notification: notificationSlice.reducer,
        // settings: settingSlice.reducer
    },
    devTools: true // 'PROD' !== (window as any).SUBTRUX_ENV
})

// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store

// Use `useAppDispatch` rather the untyped `useDispatch` from `react-redux`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()

// Use `useAppSelector` rather the untyped `useSelector` from `react-redux`
export const useAppSelector = useSelector.withTypes<RootState>()
